(function() {
  const savesMoneyLink = document.querySelectorAll('.savesMoney__title a, .savesMoney__contentButton');
  const savesMoneyContent = document.querySelector('.savesMoney__content');
  const overlap = document.querySelector('.overlap');

  function addOffsetTop() {
		const { y } = document.querySelector('body').getBoundingClientRect();

		document.querySelector('body').style.top = `${y}px`;
	}

	function removeOffsetTop() {
		if (document.querySelector('body').style.top != 'unset') {
			const y = -parseInt(document.querySelector('body').style.top);

			document.querySelector('body').style.top = 'unset';

			setTimeout(() => {
				window.scrollTo(0, y);
			}, 0);
		}
	}

  function togglePopup() {
    savesMoneyContent.classList.toggle('savesMoney__content--active');
    overlap.classList.toggle('overlap--active');
    body.classList.toggle('body--overflow');

    if (window.innerWidth < 768) {
      if (body.classList.contains('body--overflow')) {
        addOffsetTop();
      } else {
        removeOffsetTop();
      }
    }
  }

  savesMoneyLink.forEach((link) => {
    link.addEventListener('click', togglePopup);
  });
})();
